import React from "react";

// Анимация "набегающего" числа при монтировании (easeOutCubic)
export const CountUp = ({ value, decimals = 0, duration = 1000, className, style }) => {
  const target = Number(value) || 0;
  const [display, setDisplay] = React.useState(0);

  React.useEffect(() => {
    if (typeof window === "undefined" || !window.requestAnimationFrame) {
      setDisplay(target);
      return;
    }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(target * eased);
      if (t < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setDisplay(target);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return (
    <span className={className} style={style}>
      {display.toFixed(decimals)}
    </span>
  );
};
